export default __webpack_public_path__ + "static/media/merge-manta-404.cf73bb45.svg";